import axiosInstance from "../../interceptor";

const PaymentApi = {
  subscribe: (cardToken: string, amount: string, subscriptionId: number, truckCount: number, annual: boolean) => axiosInstance.post('/payment/purchase', {cardToken: cardToken, amount: amount, subscriptionId: subscriptionId, truckCount: truckCount, annual: annual}),
  cancelSubscription: () => axiosInstance.post('/payment/cancel'),
};

export default PaymentApi;